import i18next from 'i18next';
import enTranslation from './lang/_en';

const lang = document.documentElement.lang;

i18next.init(
  {
    lng: lang,
    debug: false,
    resources: {
      en: {
        translation: enTranslation,
      },
    },
  },
  function (err) {
    if (err) return;

    const translationElm = document.querySelectorAll('[data-translation]');
    if (translationElm) {
      translationElm.forEach((elm) => {
        const key = elm.getAttribute('data-translation');
        elm.innerHTML = i18next.t(key) !== key ? i18next.t(key) : elm.innerHTML;
      });
    }
  }
);
